<template>
    <div class="personal-center">
      <div class="pc-layout">
        <!-- 左侧 tab 导航 -->
        <div class="pc-sidebar">
          <div
            class="pc-tab-item"
            :class="{ active: activeName === 'userInfo' }"
            @click="activeName = 'userInfo'"
          >用户设置</div>
          <div
            class="pc-tab-item"
            :class="{ active: activeName === 'passwrod' }"
            @click="activeName = 'passwrod'"
          >密码设置</div>
        </div>

        <!-- 右侧内容 -->
        <div class="pc-content">
          <!-- 用户设置 -->
          <div v-if="activeName === 'userInfo'">
            <!-- 头像 -->
            <div class="avatar-area">
              <div class="avatar-circle">
                {{ userInfo.name ? userInfo.name.charAt(0).toUpperCase() : 'U' }}
              </div>
            </div>

            <el-form
              ref="userInfoForm"
              :model="userInfo"
              :disabled="!isShowBtn('personalCenter','个人中心','Update')"
              :rules="userInforules"
              label-position="top"
              class="pc-form"
            >
              <el-form-item prop="name" label="昵称">
                <el-input v-model="userInfo.name" clearable />
              </el-form-item>
              <el-form-item label="电话号码" prop="mobile">
                <el-input v-model="userInfo.mobile" clearable />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="userInfo.email" clearable placeholder="请输入邮箱" />
              </el-form-item>
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="userInfo.gender">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                  <el-radio :label="-1">未知</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="isShowBtn('personalCenter','个人中心','Update')">
                <el-button type="primary" @click="updateInfo" class="btn-dark">更新</el-button>
                <el-button @click="resetForm('info')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 密码设置 -->
          <div v-if="activeName === 'passwrod'">
            <el-form
              ref="userPasswordForm"
              :model="userPasswordInfo"
              :rules="passwordRules"
              label-position="top"
              class="pc-form"
            >
              <el-form-item label="原密码" required prop="oldPassword">
                <el-input v-model="userPasswordInfo.oldPassword" type="password" clearable show-password />
              </el-form-item>
              <el-form-item required prop="newPassword" label="新密码">
                <el-input type="password" v-model="userPasswordInfo.newPassword" clearable show-password />
              </el-form-item>
              <el-form-item required prop="newPassword2" label="确认密码">
                <el-input type="password" v-model="userPasswordInfo.newPassword2" clearable show-password />
              </el-form-item>
              <el-form-item v-show="isShowBtn('personalCenter','个人中心','Changepassword')">
                <el-button type="primary" @click="settingPassword" class="btn-dark">提交</el-button>
                <el-button @click="resetForm('passwordForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {systemUserUserInfoEdit,systemUserUserInfo,systemUserChangePassword} from '@/api/api'
    import {useMutitabsStore} from "@/store/mutitabs";
    import md5 from 'js-md5'
    export default {
        name: "personalCenter",
        setup(){
            const mutitabsstore = useMutitabsStore()
            return { mutitabsstore}
        },
        data() {
            var validatePass = (rule, value, callback) => {
              const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,30}')
              if (value === '') {
                callback(new Error('请输入密码'))
              } else if (value === this.userPasswordInfo.oldPassword) {
                callback(new Error('原密码与新密码一致'))
              } else if (!pwdRegex.test(value)) {
                callback(new Error('您的密码复杂度太低(密码中必须包含字母、数字)'))
              } else {
                if (this.userPasswordInfo.newPassword2 !== '') {
                  this.$refs.userPasswordForm.validateField('newPassword2')
                }
                callback()
              }
            }
            var validatePass2 = (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.userPasswordInfo.newPassword) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            }
            return{
                position: 'right',
              activeName: 'userInfo',
              userInfo: {
                name: '',
                gender: 1,
                mobile: '',
                avatar: '',
                email: ''
              },
              userInforules: {
                name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
                mobile: [
                  { pattern: /^1[3|4|5|7|8]\d{9}$/, message: '请输入正确手机号' }
                ]
              },
              userPasswordInfo: {
                oldPassword: '',
                newPassword: '',
                newPassword2: ''
              },
              passwordRules: {
                oldPassword: [
                  {
                    required: true,
                    message: '请输入原密码',
                    trigger: 'blur'
                  }
                ],
                newPassword: [{ validator: validatePass, trigger: 'blur' }],
                newPassword2: [{ validator: validatePass2, trigger: 'blur' }]
              }
            }
        },
        mounted () {
        this.getCurrentUserInfo()
        },
        methods:{
            /**
             * 获取当前用户信息
             */
            getCurrentUserInfo () {
                systemUserUserInfo().then(res=>{
                    if(res.code == 2000) {
                        this.userInfo=res.data.data
                    }

                })
            },
            /**
             * 更新用户信息
             */
            updateInfo () {
              const _self = this

              _self.$refs.userInfoForm.validate((valid) => {
                if (valid) {
                    _self.userInfo.userp
                    systemUserUserInfoEdit(_self.userInfo).then(res=>{
                            if(res.code ==2000) {
                                this.$message.success(res.msg)
                                _self.getCurrentUserInfo()
                            } else {
                                this.$message.warning(res.msg)
                            }
                        })
                } else {
                  // 校验失败
                  // 登录表单校验失败
                  this.$message.error('表单校验失败，请检查')
                }
              })
            },
            // 重置
            resetForm (name) {
              const _self = this
              if (name === 'info') {
                _self.getCurrentUserInfo()
              } else {
                _self.userPasswordInfo = {
                  oldPassword: '',
                  newPassword: '',
                  newPassword2: ''
                }
              }
            },
            // tab切换,默认切换清除原字符
            handleClick (tab, event) {
              const _self = this
              // if (tab.paneName === 'userInfo') {
              //   _self.$refs.userPasswordForm.resetFields()
              // } else {
              //   _self.$refs.userInfoForm.resetFields()
              // }
            },
            /**
             * 重新设置密码
             */
            settingPassword () {
              const _self = this

              _self.$refs.userPasswordForm.validate((valid) => {
                if (valid) {
                  const userId = this.mutitabsstore.getUserId
                  if (userId) {
                    _self.userPasswordInfo.newPassword=md5(_self.userPasswordInfo.newPassword)
                    _self.userPasswordInfo.oldPassword=md5(_self.userPasswordInfo.oldPassword)
                    _self.userPasswordInfo.newPassword2=md5(_self.userPasswordInfo.newPassword2)
                    const params = JSON.parse(JSON.stringify(_self.userPasswordInfo))
                      params.id = userId
                    systemUserChangePassword(params).then(res=>{
                            if(res.code ==2000) {
                                _self.activeName = 'userInfo'
                                this.$message.success(res.msg)
                            } else {
                                this.$message.warning(res.msg)
                            }
                        })
                  }
                } else {
                  // 校验失败
                  // 登录表单校验失败
                  this.$message.error('表单校验失败，请检查')
                    }
                  })
                }

        }
    }
</script>

<style scoped>
.personal-center {
  padding: 24px;
  max-width: 900px;
}

.pc-layout {
  display: flex;
  gap: 24px;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E5E5EA;
  overflow: hidden;
  min-height: 500px;
}

/* 左侧 tab */
.pc-sidebar {
  width: 160px;
  padding: 20px 12px;
  border-right: 1px solid #E5E5EA;
  flex-shrink: 0;
}

.pc-tab-item {
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #6E6E73;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 4px;

  &:hover { background: #F5F5F7; color: #1D1D1F; }
  &.active { background: #EBF2FD; color: #1D6FE8; font-weight: 500; }
}

/* 右侧内容 */
.pc-content {
  flex: 1;
  padding: 32px 40px;
}

/* 头像 */
.avatar-area {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.avatar-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #EBF2FD;
  color: #1D6FE8;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 表单 */
.pc-form {
  max-width: 440px;

  ::v-deep(.el-form-item__label) {
    font-size: 13px;
    color: #6E6E73;
    font-weight: 400;
    padding-bottom: 4px;
    line-height: 1.4;
  }

  ::v-deep(.el-input__wrapper) {
    border-radius: 8px !important;
    background: #FAFAFA;
  }

  ::v-deep(.el-radio__label) {
    font-size: 13px;
    color: #1D1D1F;
  }
}

/* 按钮 */
::v-deep(.btn-dark) {
  background: #1D1D1F !important;
  border-color: #1D1D1F !important;
  color: #fff !important;
  border-radius: 8px !important;
  &:hover { background: #3A3A3C !important; border-color: #3A3A3C !important; }
}
</style>
